export const DEFAULT_DISK_SIZE = 1;
export const DISK_SIZE_MIN_GI = 1;
export const DISK_SIZE_MAX_GI = 2048;
export const DISK_SIZE_MARK_COUNT = 8;
